// requires momentjs setup as a global
import { DATETIME } from '../config/'

const dateFormat = (DATETIME) ? DATETIME.DATEPICKER_FORMAT : 'YYYY-MM-DD'
const timeFormat = (DATETIME) ? DATETIME.TIMEPICKER_FORMAT : 'HH:mm'
const METER_TO_MILES = 0.000621371192

export default {
  filters: {
    distanceFormat (meters = 0) {
      if (meters > 300) {
        return (meters * METER_TO_MILES).toFixed(1) + " miles"
      }
      return Math.round(meters) + " m"      
    },
    epoch2DateFormat (msecs = 0) {
      return moment(msecs).format(dateFormat)
    },
    epoch2TimeFormat (msecs = 0) {
      return moment(msecs).format(timeFormat)
    },    
    durationFormat (secs = 0) {
      let output = ''
      let hours   = Math.floor(secs / 3600);
      let minutes = Math.floor((secs - (hours * 3600)) / 60);      
      if (hours > 0) {
        output += hours + ' hours '
      }
      if (minutes > 0) {
        output += minutes + ' min'
      } else {
        output = '< 1 min'
      }
      return output      
    }, 
    highlight (words, query) {
      return words.replace(query, '<span class="highlight">' + query + '</span>')
    },  
    capitalize (sentence) {
      return sentence.split(" ").map(x => x.charAt(0).toUpperCase() + x.slice(1)).join(" ")
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/filters.js